import styled from "styled-components";
const GameListDisplay = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  padding-right: 10px;
`;
export default GameListDisplay;
